import {Component} from '@angular/core';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public goToLink(url: string){
    window.open(url, '_blank');
  }
}
